import { SliderBreakpoint } from './types';
export const SCROLL_THROTTLE_TIMEOUT = 150;

export const DEFAULT_CONTAINER_WIDTH = 1024;
export const DEFAULT_SPACING = 16;

export const BREAKPOINTS: SliderBreakpoint[] = [
  {
    maxWidth: 480,
    elementWidth: 270,
    elementHeight: 270,
  },
  {
    maxWidth: 1024,
    elementWidth: 278,
    elementHeight: 239,
  },
  {
    maxWidth: 1280,
    elementWidth: 269,
    elementHeight: 231,
  },
  {
    maxWidth: 1366,
    elementWidth: 280,
    elementHeight: 241,
  },
  {
    maxWidth: 1920,
    elementWidth: 330,
    elementHeight: 284,
  },
];
